import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { TruncateCasePipe } from 'src/app/pipes/truncateUppercase.pipe';
import { MomentPipe } from 'src/app/pipes/moment.pipe';
import { FromNowPipe } from 'src/app/pipes/fromNow.pipe';

@NgModule({
  declarations: [SafePipe, TruncateCasePipe, MomentPipe, FromNowPipe],
  imports: [CommonModule],
  exports: [SafePipe, TruncateCasePipe, MomentPipe, FromNowPipe],
})
export class SharedPipesModule {}
